export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7b-bcec40f336c0b9258867a9ecafd72f0c.webp";